import { ENVS } from '../consts';

export const getCasdoorAccessToken = () => window.localStorage.getItem('casdoor_access_token') || '';

export const getCasdoorRefreshToken = () => window.localStorage.getItem('casdoor_refresh_token') || '';

export const removeTokens = () => {
  window.localStorage.removeItem('casdoor_access_token');
  window.localStorage.removeItem('casdoor_refresh_token');
  window.localStorage.removeItem('teachbase_access_token');
  window.localStorage.removeItem('teachbase_refresh_token');
};

export const saveCasdoorTokens = ({ accessToken, refreshToken }: { accessToken: string; refreshToken: string }) => {
  window.localStorage.setItem('casdoor_access_token', accessToken);
  window.localStorage.setItem('casdoor_refresh_token', refreshToken);
};

export const getTeachbaseAccessToken = () => window.localStorage.getItem('teachbase_access_token') || '';

export const saveTeachbaseToken = ({ accessToken }: { accessToken: string }) => {
  window.localStorage.setItem('teachbase_access_token', accessToken);
};

export const getSSOUrlToRedirect = ({
  type,
  redirectUri,
  redirectPath,
}: {
  type: 'signin' | 'signup' | 'logout' | 'admin';
  redirectUri: string;
  redirectPath?: string;
}) => {
  if (typeof window === 'undefined') {
    return '';
  }

  const url = new URL(type, ENVS.SSO_SITE_URL);
  url.searchParams.append('redirectUri', redirectUri);

  if (redirectPath) {
    url.searchParams.append('redirectPath', redirectPath);
  }

  return url.toString();
};

export const getPublicSiteUrl = () => window.location.origin || ENVS.PUBLIC_URL;

export const logoutUser = () => {
  removeTokens();

  window.location.href = getSSOUrlToRedirect({ type: 'logout', redirectUri: ENVS.LMS_LOGOUT_URL });
};
